module.exports = __webpack_public_path__ + "img/2_bg.9eb87fa6.png";